<ul class="navbar-nav mr-auto mt-2 mt-lg-0">
  <li class="nav-item active">
      <a (click)="goToHomeLanding()" class="nav-link" href="#">{{ 'header.Conócenos' | translate }}</a>
  </li>
  <li class="nav-item">
      <a (click)="goToContact()" class="nav-link" href="#">{{ 'header.Contacto' | translate }}</a>
  </li>
</ul>